<template>
    <div class="topcode-wechat-linkage-item" >
        <div class="top">
            <div class="title">{{detail.name}}</div>
            <SSwitch class="switch" :value="state" @input="onChangeState" :disabled="!permissions.includes('LINKAGE_EDIT')" size="20px"/>
        </div>
        <div class="body" @click="onClick">
            <div class="main-device-item">
                <div class="flex-center-y title">
                    <div class="circle"/>
                    {{detail.eventName}}
                </div>
                <div class="flex-center-y  device-info">
                    <img :src="getImgUrl(detail.productImage1)"/>
                    <div class="right">
                        <div class="device-name">
                            {{detail.deviceName}}({{detail.deviceSn}})
                        </div>
                        <div class="product-name">
                            {{detail.productName}}
                        </div>
                    </div>
                </div>
            </div>
            <Swipe :loop="false" :width="swipeWidth" class="device-list">
                <SwipeItem class="device-item" v-for="(item) in detail.executeList" :key="item.id">
                    <div class="content">
                    <div class="flex-center-y title">
                        <div class="circle"/>
                        {{item.actionName}}
                    </div>
                    <div class="flex-center-y  device-info">
                        <img :src="getImgUrl(item.productImage1)"/>
                        <div class="right">
                            <div class="device-name">
                                {{item.deviceName}}({{item.deviceSn}})
                            </div>
                            <div class="product-name">
                                {{item.productName}}
                            </div>
                        </div>
                    </div></div>
                </SwipeItem>
            </Swipe>
        </div>
    </div>
</template>

<script>
    import {Swipe, SwipeItem, Switch} from 'vant';
    import {downloadImg} from "@/config"
    import {mapGetters} from 'vuex'

    export default {
        components: {
            SSwitch: Switch, Swipe, SwipeItem
        },
        props: ['detail'],
        data() {
            return {
                state: false,
                screenWidth: screen.width
            }
        },
        computed: {
            ...mapGetters({permissions: 'global/permissions'}),
            swipeWidth() {
                return screen.width - (this.detail.executeList.length > 1 ? 100 : 0)
            }
        },
        created(){},
        mounted() {
            this.state = {Stop: false, Start: true}[this.detail.state] || false
        },
        methods: {
            onClick() {
                this.$router.push('/linkage/update/' + this.detail.id)
            },
            onChangeState(state) {
                const data = {id: this.detail.id, state: state ? 'Start' : 'Stop'};
                this.$http.tokiot.linkage.changeState(data)
                    .then(ret => {
                        if (ret) {
                            this.$toast.success("修改成功");
                            this.state = state
                        }
                    })
            },
            getImgUrl(url) {
                return downloadImg + url
            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    @import "../style/index.less";

    .topcode-wechat-linkage-item {
        width: 100%;
        padding-bottom: 3px;
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        & > .top {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            background: #ffffff;
            display: flex;
            padding: 8px;
            margin-bottom: 2px;

            & > .title {
                color: #333;
                width: 100%;
            }
            & > .switch {
                width: 42px;
            }
        }
        & > .body {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            background: #ffffff;
            display: flex;
            flex-direction: column;
            height: 220px;
            padding: 5px 8px;

            & > .device-list {
                padding: 5px 0;
                :first-child {
                    margin-left: 0;
                }
            }
        }
    }


</style>